import request from '@/util/request';
import qs from 'qs';

export const getCarInList = (params, options) =>
  request.get('/api/v4ward/car/carIn/page/v2', Object.assign({}, options, {
    params
  }));

export const getCarOutList = (params, options) =>
  request.get('/api/v4ward/car/carOut/page/v2', Object.assign({}, options, {
    params
  }));

export const getMoneyStatistic = (params, options) =>
  request.get('/api/v4ward/car/carOut/statisticMoney/v2', Object.assign({}, options, {
    params
  }));

export const getRemainList = (params, options) =>
  request.get('/api/v4ward/car/carRemain/page/v2', Object.assign({}, options, {
    params
  }));

export const getDetail = (params, options) =>
  request.get('/api/v4ward/car/CarInOut/detail/v2', Object.assign({}, options, {
    params
  }));

export const remove = (params, options) =>
  request.post('/api/v4ward/car/CarInOut/remove/v2', qs.stringify(params), options);

export const add = (params, options) =>
  request.post('/api/v4ward/car/CarInOut/submit/v2', params, options);

export const update = (params, options) =>
  request.post('/api/v4ward/car/CarInOut/submit/v2', params, options);

export const getParkSpaceNode = (params, options) =>
  request.get('/api/v4ward/car/parkSpaceNode/treeChildrenCarParkNode/v2?id=0', params, options);

export const getCarInGroupByPlateNumber = (params, options) =>
  request.get('/api/v4ward/car/getCarInGroupByPlateNumber/v2', Object.assign({}, options, {
    params
  }));

export const carOutByPersonOperation = (params, options) =>
  request.post('/api/v4ward/car/carOutByPersonOperation/v2', qs.stringify(params), options);

export const selectCarInByGroup = (params, options) =>
  request.get('/api/park/car/in/selectCarInByGroup/v2', Object.assign({}, options, {
    params
  }));

export const getInPassage = (params, options) =>
  request.get('/api/park/passage/getInPassage/v2', Object.assign({}, options, {
    params
  }));

export const getOutPassage = (params, options) =>
  request.get('/api/park/passage/getOutPassage/v2', Object.assign({}, options, {
    params
  }));

export const getAllGroupBySpaceId = (params, options) =>
  request.get('/api/v4ward/car/park/group/getAllGroupBySpaceId/v2', Object.assign({}, options, {
    params
  }));
// 出入场详情查询
export const inoroutDetails = (params, options) =>
  request.get("/api/client/v4ward/car/detail/v2", Object.assign({}, options, {
    params
  }));
